import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | authed | anon

  useEffect(() => {
    const token = localStorage.getItem("kf_token");
    if (!token) {
      setStatus("anon");
      return;
    }
    api.get("/auth/me")
      .then((r) => { setUser(r.data.user); setTenant(r.data.tenant); setStatus("authed"); })
      .catch(() => { localStorage.removeItem("kf_token"); setStatus("anon"); });
  }, []);

  async function login(email, password) {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("kf_token", r.data.token);
    setUser(r.data.user);
    setTenant(r.data.tenant);
    setStatus("authed");
    return r.data;
  }

  async function logout() {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("kf_token");
    setUser(null); setTenant(null); setStatus("anon");
  }

  async function refreshTenant() {
    const r = await api.get("/tenant");
    setTenant(r.data);
    return r.data;
  }

  return (
    <AuthCtx.Provider value={{ user, tenant, status, login, logout, refreshTenant, setTenant }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
